import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu";
import React from "react";
import { breakpointClasses, cn, splitBreakpointProps } from "@/lib/utils";
import type { DropdownMenuArrowProps } from "../types";

function DropdownMenuArrow({ className, ...props }: DropdownMenuArrowProps) {
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  return (
    <DropdownMenuPrimitive.Arrow
      data-slot="dropdown-menu-arrow"
      className={cn(className, classes)}
      {...native}
    />
  );
}

DropdownMenuArrow.displayName = "DropdownMenu.Arrow";

export default DropdownMenuArrow;
